module.exports = __webpack_public_path__ + "img/北京大学.de284f11.png";